// extracted by mini-css-extract-plugin
export default {"padd":"dt_nd","pagination":"dt_nf","button":"dt_R","isActive":"dt_ng","active":"dt_Z","showOfCurrent":"dt_nh"};